import { render, staticRenderFns } from "./MyTeachersPage.vue?vue&type=template&id=51411b2a&"
import script from "./MyTeachersPage.vue?vue&type=script&lang=js&"
export * from "./MyTeachersPage.vue?vue&type=script&lang=js&"
import style0 from "./MyTeachersPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports